import { addressDef } from "./address-def";

export const serviceAddressDialogDef = {
  type: "serviceAddress",
  dialogLabel: "MY_HR_EDIT_SERVICE_ADDRESS",
  ...addressDef(),
};
